import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { ReturnRequest } from '../model/ReturnRequest';

@Injectable()
export class ReturnRequestFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAllReturnRequest(language: number): Observable<RequestResponse<any[]>> {
        return this._httpClient.get<RequestResponse<any[]>>(this._urlBase + 'api/ReturnRequest/All?language='+language);
    }

    GetAllStrategyByStoreDates(storeOriginId: number, startDate: string, endDate: string, language: number) {
        return this._httpClient.get<RequestResponse<ReturnRequest[]>>(this._urlBase + 'api/ReturnRequest/StrategyByStoreDates?storeId=' + storeOriginId + '&startDate=' + startDate + '&endDate=' + endDate + '&language=' + language);
    }

    
    GetReturnRequestDetail(returnRequestId, language : number): Observable<RequestResponse<any>> {
        return this._httpClient.get<RequestResponse<any>>(this._urlBase + 'api/ReturnRequest/Detail?returnRequestId='+returnRequestId+'&&language='+language);
    }

    PutReturnRequest(parameters : any): Observable<any> {
        let body = JSON.stringify(parameters)
    
        return this._httpClient.put(this._urlBase + 'api/ReturnRequest/ApproveRequest', body, {
            headers: new HttpHeaders({'Content-Type':  'application/json'})
        })
    }
}
